import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useState } from "react";
import safariShare from "../assets/safari-share-button.png";
import safariAddToHome from "../assets/safari-add-to-home.png";
import safariAddToHome2 from "../assets/safari-add-to-home2.png";
import safari26MoreButton from "../assets/safari-26-more-button.png";
import safari26ShareButton from "../assets/safari-26-share-button.png";
import safari26SAddToHomeButton from "../assets/safari-26-add-to-home.png";
import safari26Confirm from "../assets/safari-26-confirm.png";
import androidMore from "../assets/android-more-button.png";
import androidAddToHome from "../assets/android-add-to-home.png";
import androidConfirm from "../assets/android-confirm.png";
import { isAndroid } from "react-device-detect";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { TranslationTree } from "@/translations";
import { getIOSVersion } from "@/lib/utils";

export default function InstallAppInstructions({ t }: { t: TranslationTree }) {
  const [androidDialogOpen, setAndroidDialogOpen] = useState(false);
  const [activeTab, setActiveTab] = useState(isAndroid ? "android" : "ios");
  const iosVersion = getIOSVersion();

  function OldIosInstruction() {
    return (
      <>
        <div className="font-semibold text-gray-200 my-4">
          {t.INSTALL_APP_INSTRUCTIONS.LABELS.IOS_STEP_1}
        </div>
        <img src={safariShare} className="w-full max-w-xl" />
        <div className="font-semibold text-gray-200 my-4">
          {t.INSTALL_APP_INSTRUCTIONS.LABELS.IOS_STEP_2}
        </div>
        <img src={safariAddToHome} className="w-full max-w-xl" />
        <div className="font-semibold text-gray-200 my-4">
          {t.INSTALL_APP_INSTRUCTIONS.LABELS.IOS_STEP_3}
        </div>
        <img src={safariAddToHome2} className="w-full max-w-xl" />
      </>
    );
  }

  function Ios26Instructions() {
    return (
      <>
        <div className="font-semibold text-gray-200 my-4">
          {t.INSTALL_APP_INSTRUCTIONS.LABELS.IOS_26_STEP_1}
        </div>
        <img src={safari26MoreButton} className="w-full max-w-xl" />
        <div className="font-semibold text-gray-200 my-4">
          {t.INSTALL_APP_INSTRUCTIONS.LABELS.IOS_26_STEP_2}
        </div>
        <img src={safari26ShareButton} className="w-full max-w-xl" />
        <div className="font-semibold text-gray-200 my-4">
          {t.INSTALL_APP_INSTRUCTIONS.LABELS.IOS_26_STEP_3}
        </div>
        <img src={safari26SAddToHomeButton} className="w-full max-w-xl" />
        <div className="font-semibold text-gray-200 my-4">
          {t.INSTALL_APP_INSTRUCTIONS.LABELS.IOS_26_STEP_4}
        </div>
        <img src={safari26Confirm} className="w-full max-w-xl" />
      </>
    );
  }

  return (
    <>
      <Tabs
        value={activeTab}
        onValueChange={setActiveTab}
        className="dark flex flex-col w-full items-center"
      >
        <TabsList className="w-full max-w-xl grid grid-cols-2">
          <TabsTrigger value="ios">iOS</TabsTrigger>
          <TabsTrigger value="android" className="items-center">
            Android
          </TabsTrigger>
        </TabsList>
        <TabsContent value="ios">
          {iosVersion?.major === undefined || iosVersion.major < 26 ? (
            <OldIosInstruction />
          ) : (
            <Ios26Instructions />
          )}
        </TabsContent>
        <TabsContent value="android">
          <div className="font-semibold text-gray-200 my-4">
            {t.INSTALL_APP_INSTRUCTIONS.LABELS.ANDROID_STEP_1}
          </div>
          <img src={androidMore} className="w-full max-w-xl" />
          <div className="font-semibold text-gray-200 my-4">
            {t.INSTALL_APP_INSTRUCTIONS.LABELS.ANDROID_STEP_2}
          </div>
          <p className="text-sm text-gray-400 mb-4">
            {t.INSTALL_APP_INSTRUCTIONS.LABELS.ANDROID_STEP_2_DEBUG}
            <Button
              variant="link"
              className="text-sm text-gray-400 underline px-0 ml-1"
              onClick={() => setAndroidDialogOpen(true)}
            >
              {t.INSTALL_APP_INSTRUCTIONS.LABELS.ANDROID_STEP_2_BUTTON}
            </Button>
          </p>
          <img src={androidAddToHome} className="w-full max-w-xl" />
          <div className="font-semibold text-gray-200 my-4">
            {t.INSTALL_APP_INSTRUCTIONS.LABELS.ANDROID_STEP_3}
          </div>
          <img src={androidConfirm} className="w-full max-w-xl" />
        </TabsContent>
      </Tabs>

      <Dialog open={androidDialogOpen} onOpenChange={setAndroidDialogOpen}>
        <DialogContent className="dark text-white max-h-[90vh] overflow-scroll">
          <DialogHeader>
            <DialogTitle>
              {t.INSTALL_APP_INSTRUCTIONS.LABELS.ANDROID_TIPS_TITLE}
            </DialogTitle>
            <DialogDescription>
              {t.INSTALL_APP_INSTRUCTIONS.LABELS.ANDROID_TIPS_DESCRIPTION}
            </DialogDescription>
          </DialogHeader>
          {t.INSTALL_APP_INSTRUCTIONS.LABELS.ANDROID_TIPS_LIST}
        </DialogContent>
      </Dialog>
    </>
  );
}
